export const transformarGrupos = (data) => {
  const gruposMap = {};

  data.forEach((item) => {
    const grupoId = item.idGrupo;

    if (!gruposMap[grupoId]) {
      gruposMap[grupoId] = {
        id: item.idGrupo,
        nombre: item.descGrupo?.trim(),
        subgrupos: [],
      };
    }

    gruposMap[grupoId].subgrupos.push({
      id: item.idSub,
      nombre: item.descSub?.trim(),
      codigo: item.codSub?.trim(),
      activo: item.SubActivado === 1 || item.SubActivado === "1",
    });
  });

  return Object.values(gruposMap);
};
